const cachedProcessEnv = { ...process.env };

export const getProcessEnv = () => ({
    ...cachedProcessEnv,

    // must explicitly declare process.env.NEXT_PUBLIC_* vars
    NEXT_PUBLIC_ASSET_HOST: process.env.NEXT_PUBLIC_ASSET_HOST,
    NEXT_PUBLIC_SPARKLE_ASSET_HOST: process.env.NEXT_PUBLIC_SPARKLE_ASSET_HOST,
    NEXT_PUBLIC_COLOR_ENV: process.env.NEXT_PUBLIC_COLOR_ENV,
    NEXT_PUBLIC_EVENT_RECORDER_SCRIPT:
        process.env.NEXT_PUBLIC_EVENT_RECORDER_SCRIPT,
});
